/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Method_PasskeyInputs */

const en_invite_method_passkey = /** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a passkey`)
};

/** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */
const ar_invite_method_passkey = en_invite_method_passkey;

/** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */
const he_invite_method_passkey = en_invite_method_passkey;

/** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */
const ur_invite_method_passkey = en_invite_method_passkey;

/** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */
const es_invite_method_passkey = en_invite_method_passkey;

/** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */
const fr_invite_method_passkey = en_invite_method_passkey;

/** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */
const de_invite_method_passkey = en_invite_method_passkey;

/** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */
const pt_invite_method_passkey = en_invite_method_passkey;

/** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */
const hi_invite_method_passkey = en_invite_method_passkey;

/** @type {(inputs: Invite_Method_PasskeyInputs) => LocalizedString} */
const bn_invite_method_passkey = en_invite_method_passkey;

/**
* | output |
* | --- |
* | "Use a passkey" |
*
* @param {Invite_Method_PasskeyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_method_passkey = /** @type {((inputs?: Invite_Method_PasskeyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Method_PasskeyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_method_passkey(inputs)
	if (locale === "he") return he_invite_method_passkey(inputs)
	if (locale === "ur") return ur_invite_method_passkey(inputs)
	if (locale === "es") return es_invite_method_passkey(inputs)
	if (locale === "fr") return fr_invite_method_passkey(inputs)
	if (locale === "de") return de_invite_method_passkey(inputs)
	if (locale === "pt") return pt_invite_method_passkey(inputs)
	if (locale === "hi") return hi_invite_method_passkey(inputs)
	if (locale === "bn") return bn_invite_method_passkey(inputs)
	return /** @type {LocalizedString} */ ("Use a passkey")
});